import { MealTag } from '@tovala/browser-apis-combinedapi'

export const ADD_ON_TAG_ID = 81
export const BREAKFAST_TAG_ID = 61
export const DUAL_SERVING_TAG_ID = 66

export function hasMealTag(tags: MealTag[], tagID: number) {
  return tags.some((tag) => tag.id === tagID)
}
